
    <div class="layer">
        <div class="role-main-tabs d-flex">
            <div
            (click)="notifyTabChange('general')"
            class="role-tab {{activeTab === 'general' ? 'active-tab': ''}}">
                {{ 'roles.generalTab' | translate }}
            </div>
            <div
            (click)="notifyTabChange('form')"
            class="role-tab {{activeTab === 'form' ? 'active-tab': ''}}" >
                {{ 'roles.form' | translate }}
            </div>
            <div
            (click)="notifyTabChange('statuses')"
            class="role-tab {{activeTab === 'statuses' ? 'active-tab': ''}} d-flex align-items-center" >
                {{ 'roles.statuses' | translate }}
                <span *ngIf="activeTab === 'statuses'" class="addBtn services-icon--add ml-3">{{ 'roles.statusAdd' | translate }}</span>
            </div>
            <div class="align-items-center d-flex ml-auto">
                <tutorial-layer
                        *ngIf="documentForm && documentForm.tutorials && documentForm.tutorials.general"
                        class="inpage-tutorial inline-tutorial-button"
                        title="{{ documentForm.name }}"
                        [isClosed]="true"
                        [editorData]="documentForm.tutorials.general"
                        (saveTutorial)="saveTutorial($event)">
                </tutorial-layer>
            </div>
        </div>
        <div class="role-main-tabs-content">
            <div class="role-tab-content tab-general {{activeTab === 'general' ? 'active-tab': ''}}">
                <form-description [form]="documentForm" [determinantMapById]="determinantMapById"
                                  (saveForm)="saveForm(documentForm.formSchema);"></form-description>
            </div>
            <div class="role-tab-content tab-form {{activeTab === 'form' ? 'active-tab': ''}}  {{this.store.state.common.lockedPageByUser ? 'locked-page' : ''}}">
                <div class="page-locker" *ngIf="this.store.state.common.lockedPageByUser"> </div>
                <div class="p-4">
                    <div *ngIf="serviceId && store.state.common.userLevels.pages && store.state.common.userLevels.pages.SideNavLevel >= 2"
                        class="row form-main-actions w-100 preview-button-container-sticky mt-0 py-2 align-content-center">
                        <div class="col-sm-12 closer-form">
                            <span class="align-buttons"></span>
                            <!--<user-level [page]="'DocumentForm'" [levelLabel]="'level.user'" class="ml-auto mr-3 d-flex user-level-align"></user-level>-->
                            <form-builder-actions
                                class="ml-auto"
                                [serviceId]="serviceId"
                                [myFormio]="myFormio"
                                [formKey]="'document-form'"
                                [historyHandler]="openHistory.bind(this)"
                                [historyLabelKey]="'Form history'"
                                [copyLabelKey]="'Copy'"
                                [minUserLevel]="2"
                                [downloadLabelKey]="'Copy form schema with relations'">
                            </form-builder-actions>
                        </div>
                    </div>
                    <my-formio #myFormio [serviceId]="serviceId" [formSchema]="documentForm.formSchema" formType="document-form"
                               [determinantMapById]="determinantMapById"
                               [pasteWithTransformationEnabled]="true"
                               [focusCompKey]="focusCompKey"
                               [fileLinkableWithRequirement]="true"
                               formName="form page" (saveFormSchema)="saveForm($event)"
                               class="form-form-builder form-with-preview"></my-formio>
                    <div class="shadow"></div>
                </div>
            </div>
            <div class="role-tab-content tab-statuses {{activeTab === 'statuses' ? 'active-tab': ''}}">

            </div>
        </div>
    </div>

<app-history-form
    *ngIf="showHistory"
    [serviceId]="serviceId"
    [determinantMapById]="determinantMapById"
    [historyController]="documentFormController"
    (changeForm)="changeForm($event)"
    (closeLayer)="closeHistory()">
</app-history-form>
